export const GET_JOB_APPS = 'GET_JOB_APPS';
export const CREATE_JOB_APP = 'CREATE_JOB_APP'
export const DELETE_JOB_APP = 'DELETE_JOB_APP'
export const INACTIVE_JOB_APP = 'INACTIVE_JOB_APP'
export const UPDATE_JOB_APP = 'UPDATE_JOB_APP'
export const FAVORITE_JOB_APP = 'FAVORITE_JOB_APP'

export const GET_QUOTES = 'GET_QUOTES';

export const REGISTER_USER = 'REGISTER_USER';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const SET_USER = 'SET_USER';

export const HAS_ERROR = 'HAS_ERROR';